import React, { useEffect, useState } from 'react'
import { Formik, FieldArray, Field, useFormik } from 'formik'
// import { ToastContainer, toast } from "react-toastify";
import toast from 'react-hot-toast'
import _, { set } from 'lodash'
import * as Yup from 'yup'
import { useMutation } from '@apollo/client'
import beneficiary from '../../../gql/beneficiary'
import InsurancePlans from './InsurancePlans'
import { Switch } from '@headlessui/react'
import SubscriberDetails from './SubscriberDetails'
import countries from '../../../components/CountriesList'
import AppModal from '../../../components/AppModal'
import { useNavigate } from 'react-router-dom'
import { Button, CircularProgress } from '@mui/material'
import CheckIcon from '@mui/icons-material/Check'
import eligibility from '../../../gql/eligibility'
import AddIcon from '@mui/icons-material/Add'
import DoneAllIcon from '@mui/icons-material/DoneAll'
import { useTranslation } from 'react-i18next'
import CustomFilterInput from "../../../shared/CustomFilterInput";
import AppButton from "../../../shared/AppButton";

function classNames (...classes) {
  return classes.filter(Boolean).join(' ')
}

function removeSpecialCharacters (input) {
  return input.replace(/(\d+-|\-[a-zA-Z])|[^a-zA-Z\s]/g, '')
}

function AddBeneficiaryPersonalDataForm ({
  item,
  chiReqRecord,
  setChiReqRecord,
  refetchGetById,
  systemType
}) {
  const { t } = useTranslation()
  const [addAddress, setAddAddress] = useState(false)
  const [isFormReset, setIsFormReset] = useState(false)
  const [submitEligibility, setSubmitEligibility] = useState(false)
  const [showLoader, setShowLoader] = useState(false)
  const currentDate = new Date()

  const [fromDate, setFromDate] = useState(
    `${currentDate.getFullYear()}-${String(currentDate.getMonth() + 1).padStart(
      2,
      '0'
    )}-01`
  )
  const [toDate, setToDate] = useState(
    `${currentDate.getFullYear()}-${String(currentDate.getMonth() + 1).padStart(
      2,
      '0'
    )}-${new Date(
      currentDate.getFullYear(),
      currentDate.getMonth() + 1,
      0
    ).getDate()}`
  )

  const navigate = useNavigate()

  const [
    checkEligibility,
    { data: eligibilityData, loading: loadingData, error: errorData }
  ] = useMutation(eligibility.ELIGIBILITY_CHECK, {
    update (proxy, result) {
      toast.success(t('Data send to payer successfully!'))
      navigate('/eligibility/details', {
        state: { item: result?.data?.verificationRequest }
      })
      onSuccessfulEligibilityRequestResponse(result.data)
      // if (!result?.data.verificationRequest?.nphies_err) {
      //   result.data.verificationRequest.nphies_err.map((err) => {
      //     toast.error(err.display);
      //   });
      //   setShowLoader(false);
      // } else {
      //   toast.success("Data send to payer successfully!");
      //   onSuccessfulEligibilityRequestResponse(result.data);
      // }
    },
    onError (error) {
      onEligibilityResponseError(error.graphQLErrors[0])
    }
  })

  // const { loading, error, data } = useQuery(usersGQL.GET_USER);
  const onSuccessfulEligibilityRequestResponse = data => {
    if (!data.verificationRequest.nphies_err) {
      setShowLoader(false)
      // refetch({
      //   limit: 10,
      //   page: 1,
      //   fromDate: fromDate,
      //   toDate: toDate,
      // });
    } else {
      setShowLoader(false)
      // setErrorData(data.verificationRequest.nphies_err);
      // setShowErrorAlert(true);
    }
  }

  const onEligibilityResponseError = error => {
    setShowLoader(false)
    // refetch({
    //   limit: 10,
    //   page: 1,
    //   fromDate: fromDate,
    //   toDate: toDate,
    // });
    toast.error(`${error?.message}`)
  }

  const [patientId, setPatientId] = useState(item ? item.id : null)
  const gender = [
    { id: 'male', name: t('Male') },
    { id: 'female', name: t('Female') },
    { id: 'unknown', name: t('Unknown') }
    // { id: "other", name: "Undetermined" },
  ]

  const xdocumentTypes = [
    { id: 'iqama', name: t('Iqama') },
    { id: 'Resident Card', name: t('Resident Card') },
    { id: 'Passport', name: t('Passport') },
    { id: 'Visa', name: t('Visa') },
    { id: 'National Card', name: t('National Card') },
    { id: 'Medical Record Number', name: t('Medical Record Number') }
  ]

  const documentTypes = [
    { id: 'VP', name: t('VISA') },
    { id: 'PPN', name: t('Passport') },
    { id: 'PRC', name: t('Permanent Resident Card Number') },
    { id: 'MR', name: t('Medical record number') },
    { id: 'NI', name: t('National Card') }
  ]

  const nationalities = [
    { id: 'Saudi Arabia', name: t('Saudi Arabia') },
    { id: 'Afghanistan', name: t('Afghanistan') },
    { id: 'Albania', name: t('Albania') },
    { id: 'Aland Islands', name: t('Aland Islands') }
  ]

  const residencyTypes = [
    { id: 'iqama', name: t('Iqama') },
    { id: 'visa', name: t('Visitor') },
    { id: 'nationalId', name: t('Citizen or Resident') }
  ]

  const maritalStatuses = [
    { id: 'D', name: t('Divorced') },
    { id: 'L', name: t('Legally Separated') },
    { id: 'M', name: t('Married') },
    { id: 'U', name: t('Unmarried') },
    { id: 'W', name: t('Widowed') }
  ]
  const occupationOptions = [
    { id: 'administration', name: t('Administration') },
    { id: 'agriculture', name: t('Agriculture') },
    { id: 'business', name: t('Business') },
    { id: 'education', name: t('Education') },
    { id: 'housewife', name: t('Housewife') },
    { id: 'marine', name: t('Marine') },
    { id: 'medical field', name: t('Medical Field') },
    { id: 'military', name: t('Military') },
    { id: 'skilled worker', name: t('Skilled Worker') },
    { id: 'student', name: t('Student') },
    { id: 'oil industries', name: t('Oil Industries') },
    { id: 'unemployed', name: t('Unemployed') },
    { id: 'others', name: t('Others') },
    { id: 'unknown', name: t('Unknown') }
  ]
  const religionOptions = [
    { id: '1', name: t('Muslim') },
    { id: '2', name: t('Christian') },
    { id: '3', name: t('Judaism') },
    { id: '4', name: t('Buddhism') },
    { id: '5', name: t('Zoroastrian') },
    { id: '7', name: t('Hinduism') },
    { id: '8', name: t('Sikh') },
    { id: '9', name: t('Without') },
    { id: '98', name: t('Not available') },
    { id: '99', name: t('Not mentioned') },
    { id: '0', name: t('Other') }
  ]

  const bloodGroups = [
    { id: 'O+', name: 'O+' },
    { id: 'O-', name: 'O-' },
    { id: 'A+', name: 'A+' },
    { id: 'A-', name: 'A-' },
    { id: 'B+', name: 'B+' },
    { id: 'B-', name: 'B-' }
  ]

  const visaType = [
    { id: 6, name_ar: 'مرور', name_en: t('Transit') },
    {
      id: 10,
      name_ar: 'سياحية او سياحية - هيا',
      name_en: t('Tourism or Tourist - Haya')
    },
    { id: 14, name_ar: 'توصيل بضائع', name_en: t('Cargo Delivery') },
    { id: 23, name_ar: 'زيارة تجارية', name_en: t('Business Visit') },
    { id: 24, name_ar: 'زيارة عائلية', name_en: t('Family Visit') },
    { id: 21, name_ar: 'رجال اعمال', name_en: t('Businessmen') },
    { id: 22, name_ar: 'زيارة عمل', name_en: t('Work Visit') },
    { id: 27, name_ar: 'زيارة شخصية', name_en: t('Personal Visit') },
    { id: 40, name_ar: 'مرافق', name_en: t('Accompanying') },
    { id: 30, name_ar: 'زيارة فعالية', name_en: t('Event Visit') }
  ]

  const tableHeaders = [
    {
      name: 'House No./ Apartment'
    },
    {
      name: 'Street Name'
    },
    {
      name: 'City'
    },
    {
      name: 'State/Province'
    },
    {
      name: 'Country'
    },
    {
      name: 'Postal Code'
    }
  ]

  const onSuccessfulRequestResponse = data => {
    if (data.registerPatient) {
      toast.success('Successfully Added!')
      formik.resetForm()
      setChiReqRecord(null)
      setIsFormReset(true)
      setPatientId(data.registerPatient.data.id)
      // !submitEligibility && navigate("/eligibility");
    } else {
    }
  }

  const onResponseError = error => {
    if (error?.message) {
      toast.error(`${error?.message}`)
    }
  }

  const [createPatient, { data, loading, error }] = useMutation(
    beneficiary.CREATE_PATIENT,
    {
      update (proxy, result) {
        onSuccessfulRequestResponse(result.data)
      },
      onError (error) {
        onResponseError(error.graphQLErrors[0])
      }
    }
  )

  const [
    editBeneficiary,
    { updatedData, loading: updatedLoading, updatedError }
  ] = useMutation(beneficiary.UPDATE_BENEFICIARY, {
    update (proxy, result) {
      onSuccessfulEditResponse(result.data)
    },
    onError (error) {
      onResponseError(error.graphQLErrors[0])
    }
  })

  const onSuccessfulEditResponse = data => {
    if (data?.updatePatient) {
      toast.success(data?.updatePatient?.message || 'Update Successfully!')
      formik.resetForm()
      setChiReqRecord(null)
      setIsFormReset(true)
      // refetch();
    } else {
    }
  }

  useEffect(() => {
    if (error?.graphQLErrors[0]?.message) {
      toast.error(error?.graphQLErrors[0]?.message)
    }
    if (updatedError?.graphQLErrors[0]?.message) {
      toast.error(updatedError?.graphQLErrors[0]?.message)
    }
  }, [error, updatedError])

  // const formatInputData = postData => {
  //   return {
  //     start_date: currentDate.toISOString().substring(0, 10),
  //     end_date: currentDate.toISOString().substring(0, 10),
  //     payer_id: `${
  //       postData?.insurance_plans?.length > 0 &&
  //       postData?.insurance_plans[0]?.payer_id
  //     }`,
  //     patient_id: postData?.id,
  //     insurance_plan_id: `${
  //       postData?.insurance_plans?.length > 0 &&
  //       postData?.insurance_plans[0]?.id
  //     }`,
  //     purpose: ['benefits', 'validation', 'discovery'],
  //     is_new_born: false,
  //     is_referral: false
  //   }
  // }

  const formatDate = date => {
  return date.toLocaleDateString('en-CA', {
    timeZone: 'Asia/Riyadh'
  })
}

const formatInputData = postData => {
  const today = formatDate(new Date())

  return {
    start_date: today,
    end_date: today,
    payer_id:
      postData?.insurance_plans?.length > 0
        ? postData.insurance_plans[0].payer_id
        : '',
    patient_id: postData?.id,
    insurance_plan_id:
      postData?.insurance_plans?.length > 0
        ? postData.insurance_plans[0].id
        : '',
    purpose:
      postData?.is_new_born === true
        ? ['benefits', 'validation']
        : ['benefits', 'validation', 'discovery'],
    is_new_born: postData?.is_new_born === true,
    is_referral: false
  }
}

  const addData = values => {
    let data = _.cloneDeep(values)
    delete data.subscriber_name

    if (item) {
      data['id'] = item.id

      if (data?.insurance_plans) {
        data.insurance_plans = data.insurance_plans.map(plan => {
          const { payer, ...rest } = plan
          return rest
        })
      }

      // delete data.insurance_plans;
      // delete data.subscriber_relationship;
      delete data.beneficiary_file_id

      editBeneficiary({ variables: { input: data } }).then(res => {
        refetchGetById()
        if (submitEligibility) {
          toast.loading(t('Checking Eligibility'))
          checkEligibility({
            variables: {
              input: formatInputData(values)
            }
          })
        }
      })
    } else {
      delete data.beneficiary_file_id
      // delete data.subscriber_relationship;
      createPatient({ variables: { input: data } }).then(res => {
        if (submitEligibility) {
          toast.loading(t('Checking Eligibility'))
          checkEligibility({
            variables: {
              input: formatInputData(res?.data?.registerPatient?.data)
            }
          })
        }
      })
    }
  }

  const inValidBtn = values => {
    if (!values.is_new_born && values.insurance_plans.length < 1) {
      return true
    } else {
      return false
    }
  }

  useEffect(() => {
    if (chiReqRecord) {
      formik.resetForm()
      if (systemType === '5') {
        formik.setFieldValue(
          'full_name',
          chiReqRecord?.Insurance[0]?.InsuredName ||
            chiReqRecord?.Insurance[0]?.NAME ||
            chiReqRecord?.Insurance[0]?.Name ||
            ''
        )
        formik.setFieldValue(
          'document_id',
          chiReqRecord?.Insurance[0]?.PassportNumber || ''
        )
        formik.setFieldValue('document_type', 'PPN')

        formik.setFieldValue(
          'contact_number',
          chiReqRecord?.Insurance[0]?.MobileNumber || ''
        )
        formik.setFieldValue(
          'dob',
          chiReqRecord?.Insurance[0]?.DateOfBirth || ''
        )

        formik.setFieldValue(
          'gender',
          chiReqRecord?.Insurance[0]?.Gender == 1
            ? 'male'
            : chiReqRecord?.Insurance[0]?.Gender == 2
            ? 'female'
            : chiReqRecord?.Insurance[0]?.Gender == 3
            ? 'unknown'
            : 'other' || ''
        )
      } else {
        formik.setFieldValue(
          'full_name',
          chiReqRecord?.Insurance[0]?.Name ||
            chiReqRecord?.Insurance[0]?.NAME ||
            ''
        )
        formik.setFieldValue(
          'document_id',
          chiReqRecord?.Insurance[0]?.IdentityNumber ||
            chiReqRecord?.Insurance[0]?.IDENTITYNUMBER ||
            ''
        )

        formik.setFieldValue(
          'gender',
          chiReqRecord?.Insurance[0]?.Gender == 1
            ? 'male'
            : chiReqRecord?.Insurance[0]?.Gender == 2
            ? 'female'
            : chiReqRecord?.Insurance[0]?.Gender == 3
            ? 'unknown'
            : 'other' || ''
        )
      }
    }
  }, [chiReqRecord])

  const threeMonthsAgo = new Date()
  threeMonthsAgo.setMonth(currentDate.getMonth() - 3)

  const formik = useFormik({
    initialValues: {
      first_name: item?.first_name
        ? item.first_name
        : chiReqRecord
        ? chiReqRecord?.Insurance[0]?.Name || chiReqRecord?.Insurance[0]?.NAME
        : '',
      middle_name: item?.middle_name ? item.middle_name : '',
      last_name: item?.last_name ? item.last_name : '',
      family_name: item?.family_name ? item.family_name : '',
      full_name: item?.full_name
        ? item.full_name
        : chiReqRecord
        ? chiReqRecord?.Insurance[0]?.Name || chiReqRecord?.Insurance[0]?.NAME
        : '',
      file_no: item?.file_no ? item.file_no : '',
      //dob: item?.dob ? item.dob : currentDate.toISOString().substring(0, 10),
      dob: item?.dob ? item.dob : threeMonthsAgo.toISOString().substring(0, 10),
      gender: item?.gender
        ? item.gender
        : chiReqRecord
        ? chiReqRecord?.Insurance[0]?.Gender == 1
          ? 'male'
          : chiReqRecord?.Insurance[0]?.Gender == 2
          ? 'female'
          : chiReqRecord?.Insurance[0]?.Gender == 3
          ? 'unknown'
          : 'other'
        : '',
      document_type: item?.document_type ? item.document_type : '',
      document_id: item?.document_id
        ? item.document_id
        : chiReqRecord
        ? chiReqRecord?.Insurance[0]?.IdentityNumber ||
          chiReqRecord?.Insurance[0]?.IDENTITYNUMBER
        : '',
      nphies_id: item?.nphies_id ? item.nphies_id : '',
      eHealth_id: item?.eHealth_id ? item.eHealth_id : '',
      nationality: item?.nationality ? item.nationality : '',
      residency_type: item?.residency_type ? item.residency_type : '',
      contact_number: item?.contact_number ? item.contact_number : '',
      // martial_status: item?.martial_status ? item.martial_status : "",
      blood_group: item?.blood_group ? item.blood_group : '',
      preferred_language: item?.preferred_language
        ? item.preferred_language
        : '',
      emergency_number: item?.emergency_number ? item.emergency_number : '',
      email: item?.email ? item.email : '',
      // providers_id: item?.providers_id ? item.providers_id : "",
      is_new_born: item?.is_new_born ? item.is_new_born : false,
      street_line: item?.street_line ? item.street_line : '',
      address_line: item?.address_line ? item.address_line : '',
      city: item?.city ? item.city : '',
      state: item?.state ? item.state : '',
      country: item?.country ? item.country : '',
      postal_code: item?.postal_code ? item.postal_code : '',
      subscriber_id: item?.subscriber_id ? item.subscriber_id : '',
      subscriber_name: item?.subscriber_name ? item.subscriber_name : '',
      subscriber_relationship: item?.subscriber_relationship
        ? item.subscriber_relationship
        : '',
      subscriber_insurance_plan: item?.subscriber_insurance_plan
        ? item.subscriber_insurance_plan
        : item?.insurance_plans?.[0]?.id || '',
      insurance_plans: item?.insurance_plans ? item.insurance_plans : [],
      passport_no: item?.passport_no ? item.passport_no : '',
      visa_no: item?.visa_no ? item.visa_no : '',
      visa_title: item?.visa_title ? item.visa_title : '',
      visa_type: item?.visa_type ? item.visa_type : '',
      border_no: item?.border_no ? item.border_no : '',
      insurance_duration: item?.insurance_duration
        ? item.insurance_duration
        : '',
      id: item?.id ? item.id : '',

      // yyy
      martial_status: item?.martial_status ? item.martial_status : 'U',
      occupation: item?.occupation ? item.occupation : 'others',
      religion: item?.religion ? item.religion : '1'
    },
    enableReinitialize: true,

    validationSchema: () => {
      return Yup.object().shape({
        full_name: Yup.string().required(t('Full Name is required')),
        file_no: Yup.string(),
        dob: Yup.date()
          .nullable()
          .required(t('Dob is required'))
          .max(new Date(), t('Dob cannot be in the future'))
          .typeError(t('Please enter a valid date')),
        gender: Yup.string().required(t('Gender is required')),
        document_type: Yup.string().required(t('Document Type is required')),
        document_id: Yup.string().required(t('Document id is required')),
        is_new_born: Yup.boolean(),
        insurance_plans: Yup.array().when('is_new_born', {
          is: true,
          then: schema => schema,
          otherwise: schema => schema.of(
            Yup.object().shape({
              member_card_id: Yup.string().required(
                t('Member Card ID is required')
              ),
              policy_number: Yup.string().required(
                t('Policy number is required')
              ),
              expiry_date: Yup.date().required(t('Expiry date is required')),
              issue_date: Yup.string().required(t('Issue Date is required')),
              is_primary: Yup.boolean().required(t('Is primary is required')),
              payer_id: Yup.string().required(t('Payer ID is required')),
              max_limit: Yup.number().required(t('Max Limit is required')),
              relation_with_subscriber: Yup.string().required(
                t('Relation with subscriber is required')
              ),

              // yyy
              policy_holder: Yup.string().required(
                t('Policy Holder is required')
              ),
              policy_class_type: Yup.string().required(
                t('Class Type is required')
              ),
              policy_class_id: Yup.string().required(t('Class ID is required'))
            })
          )
        }),
        // .required("At least one insurance plan is required")
        // .min(1, "At least one insurance plan is required"),
        // nphies_id: Yup.string().required("nphies_id is required"),
        // eHealth_id: Yup.string().required("eHealth_id is required"),
        // nationality: Yup.string().required("nationality is required"),
        residency_type: Yup.string().required(t('Residency type is required')),
        // contact_number: Yup.string().required("contact_number is required"),
        // martial_status: Yup.string().required("martial_status is required"),
        // emergency_number: Yup.string().required("emergency_number is required"),
        // email: Yup.string().email("Invalid email").required("email is required"),
        // street_line: Yup.string().required("street_line is required"),
        // address_line: Yup.string().required("address_line is required"),
        // city: Yup.string().required("city is required"),
        // state: Yup.string().required("state is required"),
        // country: Yup.string().required("country is required"),
        passport_no: Yup.number().transform((value, originalValue) =>
          originalValue === '' ? undefined : value
        ),
        visa_no: Yup.number().transform((value, originalValue) =>
          originalValue === '' ? undefined : value
        ),
        visa_title: Yup.string(),
        visa_type: Yup.number().transform((value, originalValue) =>
          originalValue === '' ? undefined : value
        ),
        border_no: Yup.number().transform((value, originalValue) =>
          originalValue === '' ? undefined : value
        ),
        insurance_duration: Yup.string(),
        // yyy
        martial_status: Yup.string().required(t('Marital Status is required')),
        occupation: Yup.string().required(t('Occupation is required'))
      })
    },

    onSubmit: (values, { setSubmitting }) => {
      if (values.full_name.trim() === '') {
        toast.error(t('invalid name'))
        return
      }

      addData({
        ...values,
        full_name: values.full_name,
        first_name: values.first_name || values.full_name
      })
    }
  })

  useEffect(() => {
    if (formik.values?.document_id?.length > 0) {
      if (formik.values?.document_id[0] == 1) {
        formik.setFieldValue('document_type', 'NI')
        formik.setFieldValue('residency_type', 'nationalId')
      } else if (formik.values?.document_id[0] == 2) {
        formik.setFieldValue('document_type', 'PRC')
        formik.setFieldValue('residency_type', 'iqama')
      } else if (formik.values?.document_id[0] == 4) {
        formik.setFieldValue('document_type', 'VP')
        formik.setFieldValue('residency_type', 'visa')
      }
    }
  }, [formik.values?.document_id, chiReqRecord])

  const addInsurancePlan = () => {
    const initialPlain = {
      member_card_id: '',
      policy_number: '',
      expiry_date: '',
      is_primary: true,
      payer_id: '',
      relation_with_subscriber: 'self',
      coverage_type: 'EHCPOL',
      patient_share: '0.00',
      max_limit: 0,
      network: '',
      issue_date: '',
      sponsor_no: '',
      policy_class_type: 'plan',
      policy_holder: '',
      insurance_type: '',
      insurance_status: '',
      insurance_duration: '',
      policy_class_name: ''
    }

    formik.setFieldValue('insurance_plans', [
      ...formik?.values?.insurance_plans,
      initialPlain
    ])
  }

  return (
    <>
      <div class="personal-data !p-2 !mb-3">
        <div class="personal-title !mb-2">
          <div class="inventory-svg">
            <svg
              width="26"
              height="26"
              viewBox="0 0 34 34"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <rect width="34" height="34" rx="8" fill="#F4F6F8" />
              <path
                d="M9.25 11H11.25V14H21.25V11H23.25V16H25.25V11C25.25 9.9 24.35 9 23.25 9H19.07C18.65 7.84 17.55 7 16.25 7C14.95 7 13.85 7.84 13.43 9H9.25C8.15 9 7.25 9.9 7.25 11V25C7.25 26.1 8.15 27 9.25 27H15.25V25H9.25V11ZM16.25 9C16.8 9 17.25 9.45 17.25 10C17.25 10.55 16.8 11 16.25 11C15.7 11 15.25 10.55 15.25 10C15.25 9.45 15.7 9 16.25 9Z"
                fill="#0070C2"
              />
              <path
                d="M25.25 17.5L19.76 23L16.75 20L15.25 21.5L19.76 26L26.75 19L25.25 17.5Z"
                fill="#0070C2"
              />
            </svg>
          </div>
          <div class="personal-head">
            <span>{t("Personal Data")}</span>
          </div>
        </div>
        <div class="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-5 xl:grid-cols-6  gap-1.5">
          <CustomFilterInput
            label={t("Full Name*")}
            name="full_name"
            placeholder={t("Enter Full name")}
            value={formik.values.full_name}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            error={formik.errors.full_name}
            touched={formik.touched.full_name}
          />
          <CustomFilterInput
            label={t("File No")}
            name="file_no"
            placeholder={t("Enter File No")}
            value={formik.values.file_no}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            error={formik.errors.file_no}
            touched={formik.touched.file_no}
          />
          <CustomFilterInput
            label={t("Date of Birth*")}
            name="dob"
            type="date"
            value={formik.values.dob}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            error={formik.errors.dob}
            touched={formik.touched.dob}
          />
          <CustomFilterInput
            label={t("Gender*")}
            name="gender"
            isSelect={true}
            placeholder={t("Select Gender")}
            options={gender}
            value={formik.values.gender}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            error={formik.errors.gender}
            touched={formik.touched.gender}
          />
          <CustomFilterInput
            label={t("Marital Status*")}
            name="martial_status"
            isSelect={true}
            placeholder={t("Select Marital Status")}
            options={maritalStatuses}
            value={formik.values.martial_status}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            error={formik.errors.martial_status}
            touched={formik.touched.martial_status}
          />
          <CustomFilterInput
            label={t("Occupation*")}
            name="occupation"
            isSelect={true}
            placeholder={t("Select Occupation")}
            options={occupationOptions}
            value={formik.values.occupation}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            error={formik.errors.occupation}
            touched={formik.touched.occupation}
          />
          <CustomFilterInput
            label={t("Religion")}
            name="religion"
            isSelect={true}
            placeholder={t("Select Religion")}
            options={religionOptions}
            value={formik.values.religion}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            error={formik.errors.religion}
            touched={formik.touched.religion}
          />
          <CustomFilterInput
            label={t("Document Type*")}
            name="document_type"
            isSelect={true}
            placeholder={t("Select Document Type")}
            options={documentTypes}
            value={formik.values.document_type}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            error={formik.errors.document_type}
            touched={formik.touched.document_type}
          />
          <CustomFilterInput
            label={t("Document ID*")}
            name="document_id"
            placeholder={t("Enter Document ID")}
            value={formik.values.document_id}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            error={formik.errors.document_id}
            touched={formik.touched.document_id}
          />
          <CustomFilterInput
            label={t("Residency Type*")}
            name="residency_type"
            isSelect={true}
            placeholder={t("Select Residency Type")}
            options={residencyTypes}
            value={formik.values.residency_type}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            error={formik.errors.residency_type}
            touched={formik.touched.residency_type}
          />
          <CustomFilterInput
            label={t("Contact Number")}
            name="contact_number"
            placeholder={t("Enter contact number")}
            value={formik.values.contact_number}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            error={formik.errors.contact_number}
            touched={formik.touched.contact_number}
          />
          <CustomFilterInput
            label={t("Passport Number")}
            name="passport_no"
            type="number"
            placeholder={t("Enter Passport Number")}
            value={formik.values.passport_no}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            error={formik.errors.passport_no}
            touched={formik.touched.passport_no}
          />
          <CustomFilterInput
            label={t("Visa Title")}
            name="visa_title"
            placeholder={t("Enter Visa Title")}
            value={formik.values.visa_title}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            error={formik.errors.visa_title}
            touched={formik.touched.visa_title}
          />
          <CustomFilterInput
            label={t("Visa Number")}
            name="visa_no"
            type="number"
            placeholder={t("Enter Visa Number")}
            value={formik.values.visa_no}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            error={formik.errors.visa_no}
            touched={formik.touched.visa_no}
          />
          <CustomFilterInput
            label={t("Visa Type")}
            name="visa_type"
            isSelect={true}
            placeholder={t("Select Visa Type")}
            options={visaType.map((v) => ({ id: v.id, name: v.name_en }))}
            value={formik.values.visa_type}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            error={formik.errors.visa_type}
            touched={formik.touched.visa_type}
          />
          <CustomFilterInput
            label={t("Border Number")}
            name="border_no"
            type="number"
            placeholder={t("Enter Border Number")}
            value={formik.values.border_no}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            error={formik.errors.border_no}
            touched={formik.touched.border_no}
          />

          <CustomFilterInput
            label={t("Insurance Duration")}
            name="insurance_duration"
            placeholder={t("Enter Insurance Duration")}
            value={formik.values.insurance_duration}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            error={formik.errors.insurance_duration}
            touched={formik.touched.insurance_duration}
          />
        </div>
      </div>

      {formik.values.is_new_born ? (
        <SubscriberDetails
          handleChange={formik.handleChange}
          values={formik.values}
          setFieldValue={formik.setFieldValue}
          item={item}
        />
      ) : (
        <>
          <InsurancePlans
            chiReqRecord={chiReqRecord}
            item={item}
            personalDetailValues={formik.values}
            personalDetailsAreValid={formik.isValid}
            formik={formik}
            patientId={patientId}
            setFieldValue={formik.setFieldValue}
            isFormReset={isFormReset}
            setIsFormReset={setIsFormReset}
            systemType={systemType}
          />
          {formik.errors.insurance_plans &&
          typeof formik.errors.insurance_plans === "string" &&
          formik.touched.insurance_plans ? (
            <p className="max-w-2xl text-sm leading-6 text-red-500">
              {formik.errors.insurance_plans}
            </p>
          ) : null}
        </>
      )}

      <div className="flex justify-between">
        <div className="flex items-center gap-x-1.5 px-2 h-[28px]">
          <div className="flex items-center">
            <label
              htmlFor="toggle-ref"
              className="relative inline-flex items-center cursor-pointer scale-[0.65] origin-left"
            >
              <input
                type="checkbox"
                id="toggle-ref"
                name="is_new_born"
                className="sr-only peer"
                checked={!!formik.values.is_new_born}
                onChange={() =>
                  formik.setFieldValue(
                    "is_new_born",
                    !formik.values.is_new_born,
                  )
                }
              />

              <div
                className="w-11 h-6 bg-gray-300 peer-focus:outline-none rounded-full peer 
        peer-checked:bg-primary
        /* English (LTR): Ball moves right */
        peer-checked:after:translate-x-[22px] 
        /* Arabic (RTL): Ball moves left */
        rtl:peer-checked:after:-translate-x-[22px] 
        /* Ball/Circle details */
        after:content-[''] after:absolute after:top-[2px] after:start-[2px] 
        after:bg-white after:border-gray-300 after:border after:rounded-full 
        after:h-5 after:w-5 after:transition-all after:duration-300"
              ></div>
            </label>
          </div>

          <div>
            <span className="font-bold text-[11px] text-slate-600 uppercase tracking-tight">
              {t("Is New Born?")}
            </span>
          </div>
        </div>

        <div className="">
          <AppButton
            variant="contained"
            onClick={addInsurancePlan}
            startIcon={<AddIcon />}
            className=""
            type="button"
            size="small"
            label={t("New Insurance Plan")}
          />
        </div>
      </div>
      <div className=" flex gap-2 justify-center mt-1">
        <AppButton
          variant="contained"
          onClick={formik.handleSubmit}
          isLoading={loading || updatedLoading}
          loadingText={item ? t("Updating...") : t("Saving...")}
          startIcon={<CheckIcon />}
          label={item ? t("Update Beneficiary") : t("Save Beneficiary")}
          disabled={loading || updatedLoading}
          style={{ minWidth: "180px", backgroundColor: "#0070C2" }}
        />

        <AppButton
          variant="contained"
          onClick={() => {
            setSubmitEligibility(true);
            formik.handleSubmit();
          }}
          isLoading={loadingData}
          loadingText={`${item ? t("Updating") : t("Saving")} ${t(
            "Beneficiary & Check Eligibility",
          )}`}
          label={`${item ? t("Update") : t("Save")} ${t(
            "Beneficiary & Check Eligibility",
          )}`}
          startIcon={<DoneAllIcon />}
          gradient="#0070C2"
          disabled={loadingData}
          style={{ minWidth: "220px", backgroundColor: "#0070C2" }}
          className="disabled:!text-white"
        />
      </div>
    </>
  )
}

export default AddBeneficiaryPersonalDataForm
